<template>
  <l-autocomplete
    v-model="model"
    name="states[]"
    placeholder="Search"
    :items="states"
    item-key="code"
    label="Preferred states"
    help="Select state(s) you would like to work in after graduation."
    multiple
    :max="max"
  >
    <template v-if="model.length >= max" #errorMessage>
      <div class="text-sm text-red mt-2 space-y-2">
        <p>
          Don't select more than 20 states, because
          2 in 3 employed graduates don't leave their school's state for their first
          job.
        </p>
        <p>
          If you'd like to include national schools <term text="Schools that have placed graduates in high-prestige jobs all over the country"/>
          in your report, tick the checkbox below.
        </p>
      </div>
    </template>
  </l-autocomplete>
</template>

<script setup>
import LAutocomplete from "@/components/inputs/LAutocomplete.vue"
import Term from "@/components/Term.vue"
import { useStates } from "@/composables/useStates"

const model = defineModel(Array)

const { states } = useStates()

const max = 20
</script>
